import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { SupportChannel } from "app/main/services/companyConfig.service";

@Component({
  selector: "app-support-card",
  templateUrl: "./support-card.component.html",
  styleUrls: ["./support-card.component.scss"],
})
export class SupportCardComponent implements OnInit {
  @Input() customSupportChannels: SupportChannel[] = [];
  @Input() companyLogo: string = '';
  @Input() showTitle: boolean = true;
  @Input() title: string = 'Soporte al Cliente';
  @Input() description: string = 'Estamos aquí para ayudarte con cualquier consulta';
  
  @Output() channelClick = new EventEmitter<SupportChannel>();

  ngOnInit(): void {
  }

  get hasActiveChannels(): boolean {
    return this.customSupportChannels && this.customSupportChannels.some(ch => ch.isActive);
  }

  getActiveChannels(): SupportChannel[] {
    return this.customSupportChannels.filter(ch => ch.isActive);
  }

  onChannelClick(channel: SupportChannel): void {
    this.channelClick.emit(channel);
  }

  getChannelIcon(type: string): string {
    switch (type) {
      case 'email':
        return 'fa-solid fa-envelope';
      case 'phone':
        return 'fa-solid fa-phone';
      case 'whatsapp':
        return 'fa-brands fa-whatsapp';
      case 'website':
        return 'fa-solid fa-globe';
      default:
        return 'fa-solid fa-circle-question';
    }
  }

  getChannelTooltip(channel: SupportChannel): string {
    const label = channel.label || this.getChannelTypeLabel(channel.type);
    return `${label}: ${channel.value}`;
  }

  getChannelTypeLabel(type: string): string {
    switch (type) {
      case 'email':
        return 'Email';
      case 'phone':
        return 'Teléfono';
      case 'whatsapp':
        return 'WhatsApp';
      case 'website':
        return 'Sitio Web';
      default:
        return 'Canal';
    }
  }

  getRequiredEmail(): SupportChannel | null {
    return this.customSupportChannels.find(ch => ch.type === 'email' && ch.isActive) || null;
  }

  getRequiredPhone(): SupportChannel | null {
    return this.customSupportChannels.find(ch => ch.type === 'phone' && ch.isActive) || null;
  }
}
